import { atom, PrimitiveAtom } from 'jotai';
import { ShowcaseAreaVitrineProducts } from '../../../../Interface/Vts';

export const startGuidedTourAtom = atom(false);
export const currentGuidedTourStepAtom = atom(0);
export const scaVitrineId = atom<number | null>(null) as PrimitiveAtom<number | null>;
export const activeVitrineProduct = atom<ShowcaseAreaVitrineProducts>();